import React from 'react';
 
export const Search = () => {
  return <div id="search">
           <div class="flex items-center justify-between mx-3 my-3">
             <div class="flex items-center">
               <div class="font-semibold">Chat History</div>
             </div>
           </div>
           <ul>
             <li
               class="p-3 hover:bg-gray-50 dark:hover:bg-zinc-900 border border-gray-300 dark:border-gray-500 rounded-md mb-3 mx-3 my-2 cursor-pointer"
             >
               <div class="flex gap-2 items-center">
                 <img
                   src="/images/avatars/Vector-5.png"
                   class="h-10 w-10 rounded-full"
                 />
                 <div class="font-medium">Barry Allan</div>
               </div>
               <div class="mt-2 dark:text-gray-400 text-gray-700 text-sm">
                 Lorem ipsum dolor sit amet
                 <span class="font-medium text-blue-500"
                   >consectetur adipisicing elit</span
                 >. Laudantium, placeat nam blanditiis ullam quae incidunt odio
               </div>
             </li>
             <li
               class="p-3 hover:bg-gray-50 dark:hover:bg-zinc-900 border border-gray-300 dark:border-gray-500 rounded-md mb-3 mx-3 my-2 cursor-pointer"
             >
               <div class="flex gap-2 items-center">
                 <img
                   src="/images/avatars/Vector-12.png"
                   class="h-10 w-10 rounded-full"
                 />
                 <div class="font-medium">Muhammed Ali</div>
               </div>
               <div class="mt-2 dark:text-gray-400 text-gray-700 text-sm">
                 aliquid, adipisci delectus fugiat vero nemo repellat
                 voluptatibus labore,
                 <span class="font-medium text-blue-500"
                   >consectetur adipisicing elit</span
                 >
                 odit tenetur recusandae. Id, itaque.
               </div>
             </li>
             <li
               class="p-3 hover:bg-gray-50 dark:hover:bg-zinc-900 border border-gray-300 dark:border-gray-500 rounded-md mb-3 mx-3 my-2 cursor-pointer"
             >
               <div class="flex gap-2 items-center">
                 <img
                   src="/images/avatars/Vector-7.png"
                   class="h-10 w-10 rounded-full"
                 />
                 <div class="font-medium">Cisco Ramon</div>
               </div>
               <div class="mt-2 dark:text-gray-400 text-gray-700 text-sm">
                 Ab tempore sint autem consectetur. Iure officiis quam
                 obcaecati,
                 <span class="font-medium text-blue-500"
                   >consectetur adipisicing elit</span
                 >
                 deleniti sequi aut quaerat, recusandae quasi nemo est delectus
                 reprehenderit quos ducimus ad fugiat qui amet provident
               </div>
             </li>
             <li
               class="p-3 hover:bg-gray-50 dark:hover:bg-zinc-900 border border-gray-300 dark:border-gray-500 rounded-md mb-3 mx-3 my-2 cursor-pointer"
             >
               <div class="flex gap-2 items-center">
                 <img
                   src="/images/avatars/Vector-8.png"
                   class="h-10 w-10 rounded-full"
                 />
                 <div class="font-medium">Patrice Jane</div>
               </div>
               <div class="mt-2 dark:text-gray-400 text-gray-700 text-sm">
                 <span class="font-medium text-blue-500"
                   >consectetur adipisicing elit</span
                 >
                 neque culpa omnis nihil!
               </div>
             </li>
           </ul>
  </div>
}

export default Search;